import styled from "styled-components";
import {
  sideBarWidth,
  DefaultLayoutMargin,
  DefaultLayoutPadding,
} from "common/const/const";
import { ReactComponent as BackButton } from "assets/icons/icon-back-24.svg";
import { useNavigate } from "react-router";
import { PreviousIcon } from "../icon";
import { TextHeading3, TextTitle3 } from "..";
import { colors } from "common/const/colors";

// const LayoutWrapper = styled.div`
const Defaultlayout = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: calc(
    100vw - ${DefaultLayoutMargin} * 2 - ${DefaultLayoutPadding} *
      2 -${sideBarWidth}
  );

  margin: ${DefaultLayoutMargin};
  padding: ${DefaultLayoutPadding};
  /* width: 100%;

  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start; */
  background-color: var(--White);
  border-radius: var(--border-radius-16);
  gap: 2rem;
  /* padding: 3rem;
  gap: 3rem; */
`;

// const DefaultLayout = ({
//   title,
//   subtitle,
//   showBackButton = false,
//   showLogo = false,
//   children,
// }) => {
//   const navigate = useNavigate();

//   return (
//     <LayoutWrapper>
//       <div
//         style={{
//           display: "flex",
//           flexDirection: "row",
//           alignItems: "flex-end",
//         }}>
//         {showBackButton && (
//           <PreviousIcon
//             onClick={() => navigate(-1)}
//             style={{ marginRight: "1rem" }}
//           />
//         )}
//         {title && (
//           <TextHeading3 style={{ marginRight: "0.5rem" }}>{title}</TextHeading3>
//         )}
//         {subtitle && (
//           <TextTitle3 color={colors.LightNavy}>{subtitle}</TextTitle3>
//         )}
//       </div>
//       {children}
//     </LayoutWrapper>
//   );
// };

// const DefaultLayout = styled.div`
//   display: flex;
//   flex: 1;
//   flex-direction: column;
//   justify-content: flex-start;
//   align-items: flex-start;
//   width: calc(
//     100vw - ${DefaultLayoutMargin} * 2 - ${DefaultLayoutPadding} *
//       2 -${SIDEBAR_WIDTH}
//   );
//   margin: ${DefaultLayoutMargin};
//   padding: ${DefaultLayoutPadding};
//   background-color: var(--White);
//   border-radius: var(--border-radius-16);
//   gap: 2rem;
// `;

// const WithOutSideBarLayoutContainer = styled.div`

const WithOutSideBarLayoutStyle = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  width: 100vw;

  overflow-y: auto;
`;

const WithOutSideBarLayout = ({
  isBackButton = true,
  isScroll = false,
  // needBackground = false,
  children,
}) => {
  const navigate = useNavigate();
  return (
    <WithOutSideBarLayoutStyle
      // <WithOutSideBarLayoutContainer
      style={{
        height: isScroll ? "auto" : "100vh",
        justifyContent: isScroll ? "flex-start" : "center",
        marginTop: isScroll ? "10vh" : "0",
        // backgroundColor: "#F0F0F0",
        // backgroundImage: needBackground
        //   ? `url(${require("assets/images/worldmap.png")})`
        //   : "none",
        // backgroundSize: "contain",
        // backgroundRepeat: "no-repeat",
        // backgroundPosition: "center",
      }}>
      {isBackButton && (
        <BackButton
          style={{
            position: "fixed",
            top: "2rem",
            left: "2rem",
            cursor: "pointer",
            zIndex: 901,
          }}
          onClick={() => {
            if (window.location.pathname === "/") {
              window.location.href = "/";
            } else navigate(-1);
          }}
        />
      )}

      {children}
    </WithOutSideBarLayoutStyle>
    // </WithOutSideBarLayoutContainer>
  );
};

const RowLayout = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 1rem;
`;

const RowEndLayout = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  gap: 2rem;
`;

export { Defaultlayout, WithOutSideBarLayout, RowLayout, RowEndLayout };
// export { DefaultLayout, WithOutSideBarLayout, RowLayout, RowEndLayout };
